import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Spinner } from "./icons";
import { useTheme } from "hooks/useTheme";
import { isColorDark } from "utils/utilityFunctions";

const schema = yup.object().shape({
  fullName: yup.string().required("Full Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  mobileNo: yup
    .string()
    .matches(/^\d{10,11}$/, "Invalid mobile number")
    .required("Mobile Number is required"),
});

type FormValues = {
  fullName: string;
  email: string;
  mobileNo: string;
};

type Props = {
  submitVisitorInformation: (values: FormValues) => void;
  userDetails: any;
  loading: boolean;
};

export default function InformationCaptureForm({
  submitVisitorInformation,
  userDetails,
  loading,
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
  });

  const theme = useTheme();
  return (
    <div
      style={{
        borderRadius: "22px",
        boxShadow: "5px 5px 5px 5px rgba(0, 0, 0, 0.05)",
        border: `1px solid ${isColorDark(theme.main) ? "#d1d5db" : "#d1d5db"}`,
        borderTop: `5px solid ${theme.primary}`,
        margin: "20px",
        padding: 5,
      }}
    >
      <form onSubmit={handleSubmit(submitVisitorInformation)}>
        <Input
          label="Full Name"
          {...register("fullName")}
          error={errors.fullName?.message}
          type="text"
          placeholder="Enter full name"
          {...(userDetails?.token
            ? { readOnly: true, value: userDetails?.full_name }
            : {})}
        />
        <div
          style={{
            borderTop: "1px solid #e2e8f0",
          }}
        ></div>
        <div style={{ display: "flex", flexDirection: "column" }}></div>
        <Input
          label="Email"
          {...register("email")}
          placeholder="Enter Email"
          error={errors.email?.message}
          {...(userDetails?.token
            ? { readOnly: true, value: userDetails?.email }
            : {})}
          type="text"
        />
        <div
          style={{
            borderTop: "1px solid #e2e8f0",
          }}
        ></div>
        <div style={{ display: "flex", flexDirection: "column" }}></div>
        <Input
          label="Mobile Number"
          {...register("mobileNo")}
          placeholder="Enter mobile number"
          error={errors.mobileNo?.message}
          {...(userDetails?.token
            ? { readOnly: true, value: userDetails?.phone }
            : {})}
          type="number"
        />
        {!userDetails?.token && (
          <button
            type="submit"
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              backgroundColor: loading ? "#d7d9d8" : theme.primary,
              padding: 10,
              color: "white",
              fontSize: 15,
              border: "none",
              borderRadius: 3,
              marginBottom: 10,
            }}
            disabled={loading}
          >
            {loading ? <Spinner /> : <p>Submit</p>}
          </button>
        )}
      </form>
    </div>
  );
}

// ✅ Modified Input component for react-hook-form
const Input = React.forwardRef<
  HTMLInputElement,
  { label: string; error?: string; type: string; placeholder?: string }
>(({ label, error, type, ...props }, ref) => {
  const theme = useTheme();
  return (
    <div style={{ padding: 10 }}>
      <style>
        {`
          .input-placeholder-color::placeholder {
            color: ${theme.chatHeaderText};
          }
        `}
      </style>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
        }}
      >
        <div style={{ display: "flex", justifyContent: "start" }}>
          <label style={{ fontSize: 12, color: theme.poweredByDentistFind }}>
            {label}
          </label>
        </div>

        <input
          ref={ref}
          className="information-capture-input input-placeholder-color"
          style={{
            backgroundColor: theme.main,
            color: isColorDark(theme.main) ? "#ACACAC" : "black",
          }}
          type={type}
          {...props}
        />
        {error && (
          <span
            style={{
              color: "red",
              fontSize: 13,
              marginTop: "0px",
              textAlign: "left",
            }}
          >
            {error ? error : "2"}
          </span>
        )}
      </div>
    </div>
  );
});

export { Input };
